import { Dashboard } from '@/common/dashboard/Dashboard';
import { DashboardDataProvider } from '@/common/dashboard/DashboardDataContext';
import { FilterContainer } from '@/common/dashboard/FilterContainer';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect, useState } from 'react';
import { OverallStatusCard } from './cards/OverallStatusCard';
import { RqmtCoverageCard } from './cards/RqmtCoverageCard';
import { StatusColumnCard } from './cards/StatusColumnCard';
import { TestResultsCard } from './cards/TestResultsCard';
import { useTestDashboardReqParam } from './shared/useTestDashboardReqParam';
import { TestDashboardFilters } from './TestDashboardFilters';

const defaultFormValues = { suiteCode: null, testCode: null, rqmtCode: null };

export const TestDashboard = () => {
  const rsrc = useRsrc();
  const [suites, setSuites] = useState();

  useEffect(() => {
    rsrc.data('ac', 'TEST_DASHBOARD_FILTERS_DATA_PLUGIN', {}).then((res) => {
      setSuites(res.suites);
    });
  }, []);

  if (!suites) return null;

  return (
    <Dashboard
      title="Test Dashboard"
      titleIcon={fas.faTachometer}
      entity="TEST_RES"
      defaultFormValues={defaultFormValues}
    >
      <FilterContainer>
        <TestDashboardFilters suites={suites} />
      </FilterContainer>
      <TestDashboardCards />
    </Dashboard>
  );
};

// Fetches the results once per filter change and shares them with every card
const TestDashboardCards = () => {
  const reqParam = useTestDashboardReqParam();

  return (
    <DashboardDataProvider module="ac" plugin="TEST_DASHBOARD_RESULTS_DATA_PLUGIN" reqParam={reqParam}>
      {() => (
        <SpacerLayout>
          <Spacer vertical weights={[1, 3]}>
            <Spacer>
              <OverallStatusCard />
              <TestResultsCard />
              <RqmtCoverageCard />
            </Spacer>
            <Spacer>
              <StatusColumnCard level="SUITE" />
              <StatusColumnCard level="TEST" />
              <StatusColumnCard level="RQMT" />
            </Spacer>
          </Spacer>
        </SpacerLayout>
      )}
    </DashboardDataProvider>
  );
};
